const ArrowDownLeft01Icon = /*#__PURE__*/ [
  ["path", { d: "M15 17.3497C15 17.3497 8.06166 17.8924 7.08461 16.9154C6.10755 15.9383 6.65037 9 6.65037 9M7.5 16.5L17.5 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ArrowDownLeft01Icon as default };
//# sourceMappingURL=ArrowDownLeft01Icon.js.map
